import { Auth } from 'aws-amplify';
import { notifyError } from './utils';

const getErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : 'An unexpected error occurred';

export const signInUser = async (username: string, password: string) => {
  try {
    const response = await Auth.signIn(username, password);
    return { success: true as const, data: response };
  } catch (error: unknown) {
    return sendErrorResponse(error);
  }
};

export const signOutUser = async () => await Auth.signOut();

export const getCurrentUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return { success: true as const, user };
  } catch (error: unknown) {
    return sendErrorResponse(error);
  }
};

export const getAccessJwtToken = async () => {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch (error: unknown) {
    console.error(error);
    notifyError(getErrorMessage(error));
    return '';
  }
};

export const getIdJwtToken = async () => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error: unknown) {
    console.error(error);
    notifyError(getErrorMessage(error));
    return '';
  }
};

export const sendResetPasswordCode = async (username: string, tenantDomain: string) => {
  try {
    await Auth.forgotPassword(username, { tenantDomain });
  } catch (error: unknown) {
    return sendErrorResponse(error);
  }
};

export const resetPassword = async (username: string, code: string, password: string) => {
  try {
    await Auth.forgotPasswordSubmit(username, code, password);
    return { success: true as const };
  } catch (error: unknown) {
    return sendErrorResponse(error);
  }
};

export const updateCognitoUserAttributes = async (
  attributes: Array<{
    Name: string;
    Value: string;
  } | null>,
) => {
  const user = await Auth.currentAuthenticatedUser();
  const attributesObject: { [key: string]: string } = {};
  attributes.forEach((attribute) => {
    if (attribute) {
      attributesObject[attribute.Name] = attribute.Value;
    }
  });
  const result = await Auth.updateUserAttributes(user, attributesObject);
  return { data: result };
};

const sendErrorResponse = (error: unknown) => {
  return { success: false as const, error, message: getErrorMessage(error) };
};
